import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-buttons-catalog-view',
  templateUrl: './buttons-catalog-view.component.html',
  styleUrls: ['./buttons-catalog-view.component.css']
})
export class ButtonsCatalogViewComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

 

  constructor(private router: Router){}

  ngOnInit() {
    this.renderValue = this.value.toString().toUpperCase();
  }

  onClickTariff() {
    console.log(this.rowData);
    let url : string =  'tariff-and-option-view/'+this.rowData.catalogId;
    console.log(url);
    this.router.navigate([url]);
  }

  onClickHandset() {
    console.log(this.rowData);
    let url : string =  'handset-view/'+this.rowData.catalogId;
    this.router.navigate([url]);
  }

  viewTariff(){
    return this.rowData && this.rowData.tariffVisible;
  }

  viewHandset(){
    return this.rowData && this.rowData.handsetVisible;
  }

}
